//todo testimonials carousels
let Flickity = require('flickity');

var s;
var Carousel = {
  settings: {
    frontPageElement: '.carousel-front-page',
    featuredPageElement: '.provider-featured-carousel',
    productImageCarousel: '.product-image-carousel',
    arrowShape: {
      x0: 20,
      x1: 60,
      y1: 50,
      x2: 60,
      y2: 45,
      x3: 25
    }
  },

  init: function() {
    s = this.settings;
    this.bindUIElements();
  },

  bindUIElements: function() {
    if (document.querySelectorAll(s.frontPageElement).length) {
      var flkty = new Flickity(s.frontPageElement, {
        cellAlign: 'left',
        prevNextButtons: true,
        arrowShape: s.arrowShape,
        autoPlay: 3000
      });
    }

    if (document.querySelectorAll(s.featuredPageElement).length) {
      var flktyFeatured = new Flickity(s.featuredPageElement, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        arrowShape: s.arrowShape
      });
    }

    if (document.querySelectorAll(s.productImageCarousel).length) {
      var flktyFeatured = new Flickity(s.productImageCarousel, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        arrowShape: s.arrowShape
      });
    }
  }
};

module.exports = Carousel;



// WEBPACK FOOTER //
// ./public/src/js/Carousel.js